/** Customer-facing caffeine copy (matches ingredient detail modal). */
const CAFFEINE_LABEL = {
  none: 'Caffeine free',
  low: 'Light caffeine',
  medium: 'Moderate caffeine',
  high: 'Energizing',
};

/**
 * @param {string | undefined} level
 * @param {number | undefined} mgPerServing
 * @returns {string}
 */
export function formatBlendCaffeineLabel(level, mgPerServing) {
  const base =
    (level && CAFFEINE_LABEL[level])
    || (typeof mgPerServing === 'number' && mgPerServing > 0
      ? 'Contains caffeine'
      : 'Caffeine free');

  if (level === 'none' || !(typeof mgPerServing === 'number') || mgPerServing <= 0) {
    return base;
  }

  const mg = Number.isInteger(mgPerServing)
    ? String(mgPerServing)
    : String(Math.round(mgPerServing * 10) / 10);

  return `${base} (${mg} mg/serving)`;
}
